import classnames from "classnames";
import { motion } from "framer-motion";
import React, { useState } from "react";

import { useMobile } from "@krea/customer-features/hooks";
import Button from "@krea/customer-features/shared-components/button";
import { Text } from "@krea/customer-features/shared-components/text";

import styles from "./FieldRequestExplanation.module.scss";

const motionBlock = {
  hidden: {
    opacity: 0,
    height: 0,
    marginTop: "0px",
    border: "1px solid rgba(255,255,255,0)",
  },
  visible: {
    opacity: 1,
    height: "auto",
    marginTop: "12px",
    border: "1px solid rgba(235, 232, 239, 1)",
  },
};

const FieldRequestExplanation = ({ className, title, text, preview }) => {
  const [isOpen, setIsOpen] = useState(false);
  const isMobile = useMobile();

  return (
    <>
      {!isMobile ? (
        <div
          className={classnames(
            styles.root,
            "d-flex flex-column align-items-start rounded",
            { "p-xl-6": !preview, [styles.noborder]: preview },
            className,
          )}
        >
          <h6
            className={classnames("d-none mb-4", {
              "d-xl-none": preview,
              "d-xl-block": !preview,
            })}
          >
            {title}
          </h6>

          <div
            className={classnames(styles.text, "d-none", {
              "d-xl-none": preview,
              "d-xl-block": !preview,
            })}
          >
            {text}
          </div>
        </div>
      ) : (
        <div className={classnames(className)}>
          <div className="d-flex align-items-center justify-content-center">
            <Button
              variant="text"
              size="sm"
              justify="start"
              className="text-center"
              onClick={() => {
                setIsOpen(!isOpen);
              }}
            >
              {title}
            </Button>
          </div>

          <motion.div
            className="overflow-hidden rounded"
            variants={motionBlock}
            initial="hidden"
            animate={isOpen ? "visible" : "hidden"}
            transition={{
              default: { duration: 0.6, ease: "easeOut" },
            }}
          >
            <div className="px-6 py-5">
              <Text size="sm" className="font-weight-bold">
                {text}
              </Text>
            </div>
          </motion.div>
        </div>
      )}
    </>
  );
};

export default FieldRequestExplanation;
